package org.moxultimate.topwithmox.shows.data

import kotlinx.serialization.Serializable

/**
 * ShowsResponse
 * API response model for a single show entry returned by GET /shows.
 */
@Serializable
data class ShowsResponse(
    val id: Long,
    val title: String? = null,
    val type: String? = null,
    val tags: String? = null,
    val description: String? = null,
    val videoLink: String? = null,
    val thumbnailPath: String? = null,
    val createdAt: String? = null,
)
